export const selectOption = {
  All: 'ALL',
  NONE_SELECT: 0,
  NEW: -1,
};
